import types from './types'

export const emailingContactListPost = (listId, contactListId, emailingIntegration, mergeFields) =>
    ({type: types.EMAILING_CONTACT_LIST_POST_ATTEMPT, listId, contactListId, emailingIntegration, mergeFields})

export const emailingContactListPostSuccess = (data) => ({type: types.EMAILING_CONTACT_LIST_POST_SUCCESS, data})
export const emailingContactListPostFailure = (message, code) => ({
  type: types.EMAILING_CONTACT_LIST_POST_FAILURE,
  message,
  code,
})

export const emailingContactPost = (contactId, emailingIntegration, mergeFields) =>
    ({type: types.EMAILING_CONTACT_POST_ATTEMPT, contactId, emailingIntegration, mergeFields})

export const emailingContactPostSuccess = (data) => ({type: types.EMAILING_CONTACT_POST_SUCCESS, data})
export const emailingContactPostFailure = (message, code) => ({
  type: types.EMAILING_CONTACT_POST_FAILURE,
  message,
  code,
})

export const emailingOpportunityPost = (opportunityId, emailingIntegration) => ({
  type: types.EMAILING_OPPORTUNITY_POST_ATTEMPT,
  opportunityId,
  emailingIntegration,
})
export const emailingOpportunityPostSuccess = (data) => ({type: types.EMAILING_OPPORTUNITY_POST_SUCCESS, data})
export const emailingOpportunityPostFailure = (message, code) => ({
  type: types.EMAILING_OPPORTUNITY_POST_FAILURE,
  message,
  code,
})

export const toggleSendCopyFrom = () => ({type: types.EMAILING_TOGGLE_SEND_COPY_FROM})
